<div style="min-height: 40px">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div class="loading-container pl">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<!--<mat-spinner></mat-spinner>-->
